<style src='@/resources/styles/recharge.css' scoped />

<template>
  <div class='word-block' :class='computedCls'>
      <div class='result'>
        <div class='head'>
          <div class='word'>
            {{package.name}}
            <img src="@/resources/images/icons/appetizer.png" width="35px" v-if="isAppetizer" />
            <img src="@/resources/images/icons/meal.png" width="35px" v-if="isFullCourse" />
          </div>
          <p class='blurb'>
            {{package.heading}}

            <br><br>
            <div class='benefits'>
              <div><strong>{{package.credits}}</strong> Credits</div>
              <div>About <strong>{{package.words}}</strong> personalized names.</div>
              <div v-if="seeds">
                Use for <em>"{{seeds}}"</em> or any other keywords.
              </div>
              <div v-if="! seeds">
                Use for any keywords.
              </div>
              <div v-if="isFullCourse">
                <strong>2X</strong> better value than Appetizer
              </div>

          <br>
            </div>
          </p>
            
        </div>
        <div class='body'>
            <div class='feedback'>

            <div class='option'>
              <button class='response'
                      title="Recharge with this package"
                      v-on:click="select">
                <span class='caption' v-if="! loading">
                  ${{package.price}} &mdash; Buy
                   <span class='icon' :class="package.iconCls"/>
                </span>
                  <span class="caption" v-if="loading">
                    Loading
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import DomainStatus from '../../DomainStatus'
  import Vote from "../../Vote";

  export default {
    name: 'Package',
    props: {
      package: Object,
      loading: Boolean
    },
    components: {
    },

    data: function() {
      return {
      }
    },

    computed: {
      ...mapGetters(['filters', 'ws', 'proj']),

      computedCls() {
        const blur = (this.isDisliked) ? " blur" : "";
        return  this.package.cls + blur;
      },

      seeds() {
        return this.proj.seeds.join(",")
      },

      isAppetizer() {
        return this.package.id === "app";
      },

      isFullCourse() {
        return this.package.id === "full"
      },

    },

    methods: {
      select() {
        this.$emit("selected", this.package);
      },


    },
  }
</script>
